import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from './AuthContext';
import { Navigate } from 'react-router-dom';
import AppNavbar from './Navbar';
import ParticlesBackground from './ParticlesBackground';
import './Wolf.css';

const IMAGES = [];

const Wolf = () => {
    const { isAuthenticated, isWolfUser, loading } = useAuth();
    const [selectedImage, setSelectedImage] = useState(null);
    const [images, setImages] = useState(IMAGES);

    useEffect(() => {
        fetch('/images/wolf/manifest.json')
            .then(res => res.ok ? res.json() : [])
            .then(data => {
                if (Array.isArray(data) && data.length > 0) {
                    setImages(data);
                }
            })
            .catch(() => {});
    }, []);

    const handleKeyDown = useCallback((e) => {
        if (!selectedImage) return;
        if (e.key === 'Escape') setSelectedImage(null);
        if (e.key === 'ArrowRight') {
            const idx = images.indexOf(selectedImage);
            if (idx < images.length - 1) setSelectedImage(images[idx + 1]);
        }
        if (e.key === 'ArrowLeft') {
            const idx = images.indexOf(selectedImage);
            if (idx > 0) setSelectedImage(images[idx - 1]);
        }
    }, [selectedImage, images]);

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [handleKeyDown]);

    if (loading) {
        return (
            <div className="wolf-page">
                <header className="wolf-header">
                    <AppNavbar />
                    <ParticlesBackground />
                    <div className="header-content"><h1>Wolf</h1></div>
                </header>
                <main className="wolf-main">
                    <div className="container">
                        <p style={{ textAlign: 'center', padding: '50px' }}>Loading...</p>
                    </div>
                </main>
            </div>
        );
    }

    if (!isAuthenticated || !isWolfUser) {
        return <Navigate to="/" replace />;
    }

    return (
        <div className="wolf-page">
            <header className="wolf-header">
                <AppNavbar />
                <ParticlesBackground />
                <div className="header-content">
                    <h1>Wolf</h1>
                </div>
            </header>

            <main className="wolf-main">
                <div className="container">
                    {images.length === 0 ? (
                        <p className="wolf-empty">No images yet. Add PNGs to <code>/images/wolf/</code> and update manifest.json.</p>
                    ) : (
                        <div className="wolf-gallery">
                            {images.map((img, i) => (
                                <div
                                    key={i}
                                    className="wolf-thumb"
                                    onClick={() => setSelectedImage(img)}
                                >
                                    <img
                                        src={`/images/wolf/${img}`}
                                        alt={img.replace(/\.[^.]+$/, '').replace(/[-_]/g, ' ')}
                                        loading="lazy"
                                    />
                                    <div className="wolf-thumb-label">
                                        {img.replace(/\.[^.]+$/, '').replace(/[-_]/g, ' ')}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </main>

            {selectedImage && (
                <div className="wolf-lightbox" onClick={() => setSelectedImage(null)}>
                    <button className="wolf-lightbox-close" onClick={() => setSelectedImage(null)}>&times;</button>
                    <button
                        className="wolf-lightbox-nav wolf-lightbox-prev"
                        onClick={(e) => {
                            e.stopPropagation();
                            const idx = images.indexOf(selectedImage);
                            if (idx > 0) setSelectedImage(images[idx - 1]);
                        }}
                        disabled={images.indexOf(selectedImage) === 0}
                    >
                        &#8249;
                    </button>
                    <img
                        src={`/images/wolf/${selectedImage}`}
                        alt={selectedImage.replace(/\.[^.]+$/, '').replace(/[-_]/g, ' ')}
                        className="wolf-lightbox-img"
                        onClick={(e) => e.stopPropagation()}
                    />
                    <button
                        className="wolf-lightbox-nav wolf-lightbox-next"
                        onClick={(e) => {
                            e.stopPropagation();
                            const idx = images.indexOf(selectedImage);
                            if (idx < images.length - 1) setSelectedImage(images[idx + 1]);
                        }}
                        disabled={images.indexOf(selectedImage) === images.length - 1}
                    >
                        &#8250;
                    </button>
                    <div className="wolf-lightbox-caption">
                        {selectedImage.replace(/\.[^.]+$/, '').replace(/[-_]/g, ' ')}
                        <span className="wolf-lightbox-counter">
                            {images.indexOf(selectedImage) + 1} / {images.length}
                        </span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Wolf;